import React, { useEffect, useState } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const OfflineBanner: React.FC = () => {
  const { t } = useLanguage();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showRestored, setShowRestored] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      setShowRestored(false);
    };

    const handleOnline = () => {
      setIsOnline(true);
      setShowRestored(true);
      const timer = setTimeout(() => setShowRestored(false), 3000);
      return () => clearTimeout(timer);
    };

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (isOnline && !showRestored) return null;

  return (
    <div
      className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 px-5 py-3 rounded-2xl shadow-2xl text-sm font-medium transition-all duration-500 ${
        isOnline
          ? 'bg-green-500 text-white'
          : 'bg-[#313131] text-white'
      }`}
    >
      {isOnline ? (
        <>
          <Wifi size={16} />
          {t("offlineBanner.backOnline")}
        </>
      ) : (
        <>
          <WifiOff size={16} />
          {t("offlineBanner.noConnection")}
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
